module.exports = __webpack_public_path__ + "img/banner1.f4a4d88a.png";